import { BackendHttpService } from "../backendHttpService";

export interface TechnologyCanonicalDictionaryModel {
    id: number;
    name: string;
    category: string;
    description: string | null;
}

export class TechnologyCanonicalDictionaryService extends BackendHttpService {
    private cache: TechnologyCanonicalDictionaryModel[] | null = null;

    constructor() {
        super("dictionary");
    }

    async getTechnologyCanonicals(): Promise<TechnologyCanonicalDictionaryModel[]> {
        if (this.cache) {
            return this.cache;
        }
        this.cache = await this.get<TechnologyCanonicalDictionaryModel[]>("/technology-canonicals");
        return this.cache;
    }

    clearCache(): void {
        this.cache = null;
    }
}

export const technologyCanonicalDictionaryService = new TechnologyCanonicalDictionaryService();
